import React from "react";
import "./ItemDetails.css";
import Divider from "../../../components/Divider/Divider";

const ItemDetails = ({ item, onBack }) => {
  if (!item) {
    return <div className="item-details-empty">Brak danych.</div>;
  }

  return (
    <main className="item-details">
    

      <div className="item-details-header">
  {/* LEWA STRONA — TERMINY */}
  {item.dates?.length > 0 && (
    <section className="dates-header">
      <h2>Terminy</h2>

      <div className="dates-header-list">
        {item.dates.map((date, index) => (
          <div className="date-header-entry" key={index}>

            <h3>{date.name}</h3>

            {date.date ? (
              <span className="date-header-value">
                {date.date}
              </span>
            ) : (
              <span className="date-header-pending">
                termin w przygotowaniu
              </span>
            )}

            {date.rule && (
              <div className="date-header-rule">
                {date.rule}
              </div>
            )}

          </div>
        ))}
      </div>
    </section>
  )}

  {/* PRAWA STRONA — OBRAZEK + CYTAT */}
  <div className="item-details-top">

    <div className="item-details-top-image">
      {item.image ? (
        <img
          src={item.image}
          alt={item.name}
          className="item-details-image"
        />
      ) : (
        <div className="item-details-image-placeholder">
          <span>📷</span>
        </div>
      )}
    </div>

    {item.quote && (
      <blockquote className="item-details-quote">
        <p>{item.quote}</p>

        {item.quoteAuthor && (
          <cite>— {item.quoteAuthor}</cite>
        )}
      </blockquote>
    )}

  </div>
</div>

<Divider/>

<h1 className="item-details-title">{item.name}</h1>

      {item.meetings?.length > 0 && (
  <section className="item-details-section meeting-section">
    <h2>Spotkania</h2>

    <div className="meetings-list">
      {item.meetings.map((meeting, index) => (
        <div className="meeting-item" key={index}>

          <div className="meeting-date">
            <span className="meeting-day">
              {meeting.date}
            </span>

            <span className="meeting-time">
              {meeting.time}
            </span>
          </div>

          <div className="meeting-content">
            <p className="meeting-text">
              {meeting.text}
            </p>
          </div>

        </div>
      ))}
    </div>
  </section>
)}

{item.announcements?.length > 0 && (
  <section className="item-details-section announcements-section">
    <h2>Ogłoszenia</h2>

    <div className="announcements-board">
      {item.announcements.map((announcement, index) => (
        <article
          className={`announcement announcement-${index % 4}`}
          key={index}
        >
          <div className="announcement-pin"></div>

          <div className="announcement-paper">
            <p className="announcement-title">
              {announcement}
            </p>
          </div>
        </article>
      ))}
    </div>
  </section>
)}



      {item.documents?.length > 0 && (
        <section className="item-details-section">
          <h2>Wymagane dokumenty</h2>
          <div className="item-documents">
            <div className="item-documents-grid">
              {item.documents.map((doc, index) => (
                <div className="item-document-item" key={index}>
                  <p className="item-document-name">{doc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}


      <section className="item-details-section">
        <h2>Informacje</h2>

        <div className="item-info">
          {item.description && (
            <div className="item-info-row">
              <span className="item-info-label">Opis</span>
              <p>{item.description}</p>
            </div>
          )}
        </div>

        <div className="item-info">
          {item.description && (
            <div className="item-info-row">
              <span className="item-info-label">Procedura</span>
              <p>{item.description}</p>
            </div>
          )}
        </div>

        <div className="item-info">
          {item.links && item.links.length > 0 && (
            <div className="item-info-row">
              <span className="item-info-label">Linki</span>
              <p>{item.description}</p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default ItemDetails;